import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class ImageSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('[data-js="image-slide"]'),
    this.dom.slides = this.dom.slider.querySelectorAll('.splide__slide');

    this.dir = this.dom.el.dataset.dir;

    this.slider = null;

    this.option = {
      autoplay: true,
      // autoWidth: true,
      focus: 'center',
      type: 'loop',
      rewind: true,
      perPage: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      // drag: false,
      direction: this.dir,
      interval: 5000,
      speed: 2000,
      arrows: false,
      pagination: false,
      padding: `${37.5 / 375 * 100}vw`,
      gap: `${15 / 375 * 100}vw`,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 1,
          padding: 0,
          focus: 1,
          // padding: { left: `${288 / 1440 * 100}vw`, right: `${88 / 1440 * 100}vw` },
          padding: {
            right: (this.dir !== 'rtl') ? `${632 / 1440 * 100}vw` : 0,
            left: (this.dir === 'rtl') ? `${632 / 1440 * 100}vw` : 0
          },
          gap: `${24 / 1440 * 100}vw`,
        }
      }
    };

    this.init();
  }

  init() {

    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default ImageSlides